// Utilities
import { createPinia, setMapStoreSuffix } from 'pinia'

console.log(`
              .-*%@@@@@@@*
            +@@@@@@@@@@@@@@-       .
          -+%@@@@=:#@@@@@@@@@=-++++++*=.
        .-+++=*#**+:.#@@@@@@@@%+-.    .-+:
        +*+==+*+-::=-+#%@%#+:            :
      -+=++**=----=+#*+-.              .:
      ++****+++:.:-=:. .::--::::
      -***==--.   -----::::-==-::-
        =++-.    .-====-:...-==:.:
        .+-=:..  -====----::---:++
        .--:-=. :=======-------%@
          :----  .-----==-:...-#@:
            .--:    ..::-:  ..=**%.
            :=:       ..  ::-+#%-
            .-:              :==-
            .::              :--==-..
        ....:::.                 .+#**+-     :.
      .::::.  -:::....     .#@=.    :+++*+-   -*.
    .:-:.     ---=----:.::-#@@=..    :-===-  .=*#=
  :--...     ..:=++==---:----      ..-=--. .:::-+=.
  :+=              .     ......    ..::::....  ..=++-.
. -.                   ...::-:    .:::..      .:-=:=+-.
  @@@@ @@  @@  @@@@@ @@@@@@       .--:.          -:.-==:
    @@ @@  @@ @@       @@         .:.      .     .: : :=:
    @@ @@  @@ @@       @@        .    .    .     .= :  .-:
    @@ @@  @@  @@@@    @@        .  .-.     .     :=-   .::
@@  @@ @@  @@     @@   @@        .. :::... .*-     :-    -::
@@  @@ @@  @@     @@   @@      : -: -...:. .+-*=.  ..    :::
 @@@@   @@@@  @@@@@    @@      :.:. --#-.  ::=-+.   .     -:.
                                .     -*:     -:-..        .:.

@@@@@  @@@@@   @@@@  @@@@@  @@  @@ @@  @@ @@@@@@    @@ @@@@@@
@@  @@ @@  @@ @@  @@ @@  @@ @@  @@ @@  @@     @@    @@   @@
@@  @@ @@  @@ @@  @@ @@  @@ @@  @@ @@  @@    @@     @@   @@
@@@@@  @@@@@  @@  @@ @@  @@ @@  @@ @@  @@   @@      @@   @@
@@     @@ @@  @@  @@ @@  @@ @@  @@ @@  @@  @@       @@   @@
@@     @@  @@ @@  @@ @@  @@ @@  @@ @@  @@ @@     @@ @@   @@
@@     @@  @@  @@@@  @@@@@   @@@@   @@@@  @@@@@@ @@ @@   @@                                                                                                   
`)



setMapStoreSuffix('_store')
export default createPinia()
